import {INVALID_SESSION} from "../types";

const invalidSession= (restart = false) => async (dispatch, getState) => {
  let currentPath=getState().router.location.pathname;
  //if redirected to login don't save path
  if((!getState().auth.invalidSessionPath  && currentPath!=='/') || restart)
    dispatch({type: INVALID_SESSION, payload: {auth: {invalidSessionPath: restart ? null : currentPath}}});
};
export default invalidSession;